/*
 * @Author: bbqin
 * @Date: 2023-02-15 10:53:15
 * @LastEditTime: 2023-09-09 16:55:20
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\SmartCard\libs\utils.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import { getSafeRandom, pageTo, getGlobalStorage, setGlobalStorage } from '@platform/api';
/**
 * 生成唯一标识
 */
export function uuidv4() {
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (getSafeRandom() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

const getVarType = function (v) {
    return Object.prototype.toString.call(v).slice(8, -1);
};

/**
 * 判断是否为对象
 * @param {object} obj 
 */
export function isObject(obj) {
    return getVarType(obj) === 'Object';
}

/* 检测类型是否为数组 */
export function isArray(param) {
    return getVarType(param) === 'Array' || Array.isArray(param);
}

/* 检测类型是否为字符串 */
export function isString(param) {
    return getVarType(param) === 'String';
}

/* 检测类型是否为方法 */
export function isFunction(param) {
    return getVarType(param) === 'Function';
}

/* 检测类型是否为Promise对象 */
export function isPromise(param) {
    return getVarType(param) === 'Promise';
}

/* 检测类型是否为数字 */
export function isNumber(param) {
    return getVarType(param) === 'Number' && !Number.isNaN(param);
}

/*
 * @method   检测是否是需要是boolean类型
 */
export function isBoolean(param) {
    return getVarType(param) === 'Boolean';
}

/*
 * @method   是否是undefined
 */
export function isUndefined(origin) {
    return typeof origin === 'undefined' || origin === void 0;
}

/**
 * 用于缓存数据
 */
export const uniqueId = uuidv4();

const StorageKey = 'smartCard_retain_';

/**
 * 获取页面的单据信息，用于缓存等操作
 * @returns {BillInfo}
 */
export function getBillInfo() {
    const { appcode = '_ccc_', pagecode = '_ppp_' } = pageTo.getPageContext() || {};
    return { appcode, pagecode };
}

/**
 * 获取缓存的meta数据
 * @param {string} moduleId 
 * @returns {array}
 */
export function getCacheMeta(moduleId, billInfo = {}) {
    let cacheMeta = null;
    const { appcode = '', pagecode = '' } = billInfo;
    if (!appcode || !pagecode) {
        console.warn('缺少必要的页面属性pagecode或者appcode');
    }

    // 如果id是默认唯一id 则不进行缓存
    if (uniqueId === moduleId) {
        return cacheMeta;
    }
    const cacheKey = StorageKey + pagecode + appcode + moduleId;
    cacheMeta = getGlobalStorage('localStorage', cacheKey);
    cacheMeta = isString(cacheMeta) ? JSON.parse(cacheMeta) : cacheMeta;
    cacheMeta = cacheMeta || {};
    cacheMeta.meta = isString(cacheMeta.meta) ? JSON.parse(cacheMeta.meta) : cacheMeta.meta;

    return cacheMeta;
}

/**
 * 设置缓存的meta数据
 * @param {string} moduleId 
 * @param {array} meta 
 * @returns {array}
 */
export function setCacheMeta(moduleId, meta = {}, ts, billInfo = {}) {
    const { appcode = '', pagecode = '' } = billInfo;
    if (!appcode || !pagecode) {
        console.warn('缺少必要的页面属性pagecode或者appcode');
    }
    // 如果id是默认唯一id 则不进行缓存
    if (uniqueId === moduleId) {
        return meta;
    }
    const cacheKey = StorageKey + pagecode + appcode + moduleId;
    meta = isString(meta) ? meta : JSON.stringify(meta);
    const data = JSON.stringify({ meta, ts });
    setGlobalStorage('localStorage', cacheKey, data, e => {
        Object.keys(localStorage).forEach(item => {
            if (item.includes('appTempletStorage_')) {
                delete localStorage[item];
            }
        });
        setGlobalStorage('localStorage', cacheKey, data);
    });
    return meta;
}

// get nearest parent element matching selector   origin from stackoverflow  add by bbqin
export const Closest = function (el, selector) {
    if (!el) {
        return null;
    }
    var matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

    while (el) {
        if (matchesSelector.call(el, selector)) {
            break;
        }
        el = el.parentElement;
    }
    return el;
};

export const cloneObject = function (data) {
    const str = JSON.stringify(data);
    return JSON.parse(str);
};

/**
 * 定时器，检测是否完成，然后执行
 * @param {function} callback 
 * @param {string} condition 
 * @param {number} time 
 * @param {number} maxCount 
 */
export const runInterval = (callback, condition, time = 100, maxCount = 10) => {
    // 检测后执行
    var count = 0;
    var pid = setInterval(() => {
        let res = condition && condition();
        count++;
        if (res || count === maxCount) {
            clearInterval(pid);
            console.log(`runInterval callback use ${count} 次，耗时 ${count * time}`);
            callback && callback();
        }
    }, time);
};

/**
 * @description: 防抖函数
 * @param {type} 
 * @return: 
 */
export function debounce(func, delay) {
    var timeout;
    return function () {
        clearTimeout(timeout);
        var context = this, args = arguments;
        timeout = setTimeout(function () {
            func.apply(context, args);
        }, delay);
    };
}

/**
 * @description: 节流函数
 * @param {type} 
 * @return: 
 */
export function throttle(fn, delay) {
    var timeout;
    var start = new Date;
    var threshHold = delay || 160;
    return function () {
        var context = this, args = arguments, curr = new Date() - 0;
        clearTimeout(timeout);
        if (curr - start >= threshHold) {
            fn.apply(context, args);
            start = curr;
        } else {
            timeout = setTimeout(function () {
                fn.apply(context, args);
            }, threshHold);
        }
    };
}

export const Preset = {
    approval: {
        tabId: 'tab_approve',
        walletId: 'tab_approve_wallet',
        cardId: '_card_approveSteps',
        path: '../../../../uap/common/components/ApproveComments/index.js',
        effectVisible: ['billid', 'billtype'],
    },
    auditing: {
        tabId: 'tab_auditing',
        walletId: 'tab_auditing_wallet',
        cardId: 'SmartCard_SSCIA_AuditSidebar',
        path: '../../../../sscia/auditSidebar/components/auditSidebar4SmartCard/index.js',
        effectVisible: ['showAuditSideBar'],
    },
};